import React, { createContext, useContext, useReducer } from 'react';

const AlertFormContext = createContext();

const initialState = {
  accountData: {
    assignment: 'primary',
    subaccount: {}
  },
  conditionData: {
    condition: undefined,
    alertThreshold: '',
    precision: 'hour'
  },
  metricData: {
    selectedMetric: null
  },
  alertData: {
    name: ''
  },
  measurementData: {
    measurementType: 'by-value'
  },
  notificationData: {
    isEmailChecked: false,
    emails: [],
    isSlackChecked: false,
    slack: '',
    isWebhookChecked: false,
    webhook: '',
    time: {
      range: 'anytime',
      days: [],
      startTime: '',
      startPeriod: 'AM',
      endTime: '',
      endPeriod: 'AM',
      timeZone: ''
    }
  }
};

function reducer(state, action) {
  switch (action.type) {
    case 'UPDATE_ACCOUNT_DATA':
      return { ...state, accountData: { ...state.accountData, ...action.data } };
    case 'UPDATE_MEASUREMENT_DATA':
      return { ...state, measurementData: { ...state.measurementData, ...action.data } };
    case 'UPDATE_CONDITION_DATA':
      return { ...state, conditionData: { ...state.conditionData, ...action.data } };
    case 'UPDATE_METRIC_DATA':
      return { ...state, metricData: { ...state.metricData, ...action.data } };
    case 'UPDATE_ALERT_DATA':
      return { ...state, alertData: { ...state.alertData, ...action.data } };
    case 'UPDATE_NOTIFICATION_DATA':
      return { ...state, notificationData: { ...state.notificationData, ...action.data } };
    case 'UPDATE_NOTIFICATION_TIME':
      return {
        ...state,
        notificationData: {
          ...state.notificationData,
          time: { ...state.notificationData.time, ...action.data }
        }
      };
    case 'CLEAN_UP':
      return initialState;
    default:
      throw new Error();
  }
}

export function AlertFormContextProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <AlertFormContext.Provider
      value={{
        state,
        dispatch
      }}
    >
      {children}
    </AlertFormContext.Provider>
  );
}

export const useAlertForm = () => useContext(AlertFormContext);
